<template>
  <div class="ie11-errormsg">
    <div class="container">
      You appear to be using IE 11. <strong>The Clearing House is optimized for use with modern browsers, and some features may not work in IE 11.</strong>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BrowserError',
}
</script>